export default "__VITE_ASSET__C3o60eaH__"